import CalculusHelper from './CalculusHelper';
import { DonutSlice } from './DonutSlice';
import './DonutChart.css';

interface DonutChartProps {
  data: DonutSlice[];
  radius: number;
  viewBox: number;
  borderSize: number;
  stopOrder: number;
  anyApproximatedLocation: boolean;
  anyR30Addresses: boolean;
}

const DonutChart = ({
  data,
  radius,
  viewBox,
  borderSize,
  stopOrder,
  anyApproximatedLocation,
  anyR30Addresses,
}: DonutChartProps) => {
  let circleFillColor = 'white';
  if (anyApproximatedLocation) {
    circleFillColor = '#006dee';
  }
  if (anyR30Addresses) {
    circleFillColor = '#d946ef';
  }

  return (
    data && (
      <svg
        className="donut-svg"
        viewBox={`0 0 ${viewBox} ${viewBox}`}
        width={viewBox}
        height={viewBox}
      >
        {CalculusHelper.getSlicesWithCommandsAndOffsets(
          data,
          radius,
          viewBox,
          borderSize,
        ).map((slice) => (
          <path
            key={slice.id} // Use slice.id or index?
            fill={slice.color}
            d={slice.commands}
            transform={`rotate(${slice.offset})`}
            className="donut-path"
          >
            <title>{slice.label}</title>
          </path>
        ))}

        <circle
          cx={7.5}
          cy={7}
          r={Math.round(radius * 0.6)}
          fill={circleFillColor}
        />
        <text
          x={Math.round(viewBox * 0.45)}
          y={Math.round(viewBox * 0.1)}
          dominantBaseline="middle"
          textAnchor="middle"
          transform="translate(0, 6)"
          fill={anyApproximatedLocation || anyR30Addresses ? 'white' : 'black'}
        >
          {stopOrder}
        </text>
      </svg>
    )
  );
};

export default DonutChart;
